/* Axios */
import axios from "axios";

/*export const BASE_URL = process.env.REACT_APP_API_BASE_URL;*/
export const BASE_URL = process.env.REACT_APP_LOCAL_API_BASE_URL;
export const BASIC_AUTH_FRAMES = process.env.REACT_APP_OEF_IFRAME_AUTH;
export const BASE_FRAMES_URL = process.env.REACT_APP_OEF_FRAMES_URL;


/**
 * Requête axios de base.
 *
 * @type {axios.AxiosInstance}
 */
export const axiosBase = axios.create({
    baseURL: BASE_URL,
    withCredentials: true
});

/**
 * Instance axios réutilisable avec jeton d'authentification.
 * Cette instance sera configurée avec des intercepteurs dans useAxiosPrivate.
 *
 * @type {axios.AxiosInstance}
 */
export const axiosPrivate = axios.create({
    baseURL: BASE_URL,
    headers: {
      'Content-Type': 'application/json'
    },
    withCredentials: true
});

/**
 * AXIOS POST requests sécurisée par jeton.
 *
 * @param {string} url URL des routes à appeler.
 * @param {object} body Données envoyées en body.
 * @param {string} token Jeton d'authentification.
 * @returns {object} Réponse de l'API ou erreur en cas d'erreur.
 */
export function postRequest(url, body, token) {
  return axiosPrivate
    .post(url, body, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    })
    .then((response) => response.data)
    .catch((error) => error);
}

/** AXIOS POSET requests sans jeton d'authentification.
 *
 * @param {string} url URL des routes à appeler.
 * @param {object} body Données envoyées en body.
 * @returns {object} Réponse de l'API ou erreur en cas d'erreur.
 */
export function postRequestWithoutToken(url, body) {
  return axiosBase
    .post(url, body, {
      headers: {
        'Content-Type': 'application/json'
      },
        withCredentials: true
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error('External API Error:', error);
      return error;
  });
}

/**
 * Instance axios réutilisable pour les requêtes "frames" (API externe protégée par Basic Auth).
 *
 * @type {axios.AxiosInstance}
 */
export const axiosFrames = axios.create({
    baseURL: BASE_FRAMES_URL,
    headers: {
        'Content-Type': 'application/json',
        'Authorization': `Basic ${BASIC_AUTH_FRAMES}`
    },
    withCredentials: true
});

/**
 * AXIOS GET request sécurisée par jeton.
 *
 * @param {string} url URL des routes à appeler.
 * @param {string} token Jeton d'authentification.
 * @returns {object} response Réponse de l'API ou erreur en cas d'erreur.
 */
export function getRequest(url, token) {
    return axiosPrivate
        .get(url, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        })
        .then((response) => response.data)
        .catch(error => {
            if (error?.response) {
                console.error(`API Error [${error.response.status}] ${url}:`, error.response.data);
            } else if (error?.request) {
                console.error(`Network Error ${url}:`, error.message);
            } else {
                console.error(`Request Error ${url}:`, error.message);
            }
            return error;
        });
}

/**
 * AXIOS GET request pour les frames (Basic Auth, cf. axiosFrames).
 *
 * @param {string} url URL des routes à appeler.
 * @returns {object} response Réponse de l'API ou erreur en cas d'erreur.
 */
export function getRequestFrames(url) {
    return axiosFrames
        .get(url)
        .then((response) => response.data)
        .catch(error => {
            if (error?.response) {
                console.error(`API Error [${error.response.status}] ${url}:`, error.response.data);
            } else if (error?.request) {
                console.error(`Network Error ${url}:`, error.message);
            } else {
                console.error(`Request Error ${url}:`, error.message);
            }
            return error;
        });
}

/**
 * AXIOS POST request pour les frames (Basic Auth, cf. axiosFrames).
 *
 * @param {string} url URL des routes à appeler.
 * @param {object} body Données envoyées en body.
 * @returns {object} response Réponse de l'API ou erreur en cas d'erreur.
 */
export function postRequestFrames(url, body) {
    return axiosFrames
        .post(url, body)
        .then((response) => response.data)
        .catch(error => {
            if (error?.response) {
                console.error(`API Error [${error.response.status}] ${url}:`, error.response.data);
            } else if (error?.request) {
                console.error(`Network Error ${url}:`, error.message);
            } else {
                console.error(`Request Error ${url}:`, error.message);
            }
            return error;
        });
}

/**
 * AXIOS GET request with FILE sécurisée par jeton.
 *
 * @param {string} url URL des routes à appeler.
 * @param {string} token Jeton d'authentification.
 * @returns {object} response Réponse de l'API ou erreur en cas d'erreur.
 */
export function getRequestFile(url, token) {
    return axiosPrivate
        .get(url, {
          responseType: 'blob',
          headers: {
            'Authorization': `Bearer ${token}`
          }
        })
        .then((response) => response.data)
        .catch(error => {
            console.log(error);
        });
}

/**
 * AXIOS POST request with FILE sécurisée par jeton.
 *
 * @param {string} url URL des routes à appeler.
 * @param {object} body Données envoyées en body.
 * @param {string} token Jeton d'authentification.
 * @returns {object} response Réponse de l'API ou erreur en cas d'erreur.
 */
export function postRequestFile(url,body,token) {
    return axiosPrivate
        .post(url, body, {
          responseType: 'blob',
          headers: {
            'Authorization': `Bearer ${token}`
          }
        })
        .then((response) => response.data)
        .catch(error => {
            console.log(error);
            return error;
        });
}
